var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuymeacoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 4l-1.946 4.665H11v4.205h1.112l1.128 7.463h-1.768l2.336 13.717 1.501-.017L16.817 44h14.27l.1-.667 1.408-9.3 1.42.017 2.337-13.718h-1.69l1.128-7.462H37V8.667h-3.07L31.984 4H15.834zm.845 1.342h14.47l1.234 2.966H15.44l1.24-2.966zm-4.4 4.661h23.433v1.534H12.279v-1.534zm.724 11.664h21.82L32.94 32.7l-9.04-.1-9.018.1-1.879-11.033z",
    fill: "#F2D648"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuymeacoffee);
export default __webpack_public_path__ + "static/media/buymeacoffee.891949c58d85c47261c963a56897e419.svg";
export { ForwardRef as ReactComponent };